import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { registerGuard } from './router-guard'
import IdentityCallback from '@/views/authentication/IdentityCallback.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '/wip',
          alias: '',
          name: 'wip',
          meta: { title: 'WIP Jobs' },
          component: () => import('@/views/WipView.vue'),
        },
        {
          path: '/completed',
          name: 'completed',
          meta: { title: 'Completed Jobs' },
          component: () => import('@/views/CompletedView.vue'),
        },
      ],
    },
    {
      path: '/identity/callback',
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'identityCallback',
          component: IdentityCallback,
        },
      ],
    },
    {
      path: '/signin/error',
      name: 'signinError',
      component: () => import('@/views/authentication/SigninError.vue'),
      meta: {
        title: 'Signin Error',
        allowAnonymous: true,
      },
    },
  ],
})

registerGuard(router)

export function useTitle(title?: string) {
  document.title = [title, `${import.meta.env.VITE_APP_TITLE}`]
    .filter((t) => !!t)
    .join(' | ')
}

router.afterEach((to) => {
  useTitle(to.meta.title as string)
})

export default router
